<template>
  <div>
    <p
      v-if="!isShow && !itemData.addShow"
      class="item-tree"
    >
      <span
        v-if="itemData.title && itemData.title.indexOf(serword) >-1"
        class="item-tit-name"
        :title="itemData.title"
      >
        {{ itemData.title.substr(0, itemData.title.indexOf(serword)) }}
        <span style="color: #f50">{{ serword }}</span>
        {{ itemData.title.substr(itemData.title.indexOf(serword) + serword.length) }}
      </span>
      <span
        v-else
        class="item-tit-name"
        :title="itemData.title"
      >
        {{ itemData.title }}
      </span>
      <span class="op-tool">
        <i
          class="edit-icon icon iconfont iconicon-test21"
          @click="editName(itemData)"
        />
        <i
          v-if="itemData.level !== 2"
          class="edit-icon icon iconfont iconicon-test12"
          @click="addName(itemData)"
        />
        <i
          class="edit-icon icon iconfont iconicon-test8"
          :class="{hide: datas.options.length <= 1 && itemData.level === 1}"
          @click="delName"
        />
        <i
          class="edit-icon icon iconfont iconicon-test72"
        />
      </span>
    </p>
    <a-form
      v-if="isShow"
      :form="form"
      layout="inline"
      class="add-tree-item-form"
    >
      <a-form-item
        class=""
        :required="true"
      >
        <a-input
          v-decorator="['name', {rules: [{ required: true, message: noEmpty }],initialValue: itemData.title || ''}]"
          maxlength="30"
          :placeholder="enterPlaceholder"
        />
      </a-form-item>
      <a-form-item>
        <a-button
          type="primary"
          @click="editForm"
        >
          {{ $t('message["915"]') }}
        </a-button>
        <a-button @click="resetForm">
          {{ $t('message["896"]') }}
        </a-button>
      </a-form-item>
    </a-form>
    <a-form
      v-if="itemData.addShow"
      :form="form"
      layout="inline"
      class="add-tree-item-form"
    >
      <a-form-item
        class=""
        :required="true"
      >
        <a-input
          v-decorator="['name', {rules: [{ required: true, message: noEmpty }],initialValue:''}]"
          maxlength="30"
          :placeholder="enterPlaceholder"
        />
      </a-form-item>
      <a-form-item>
        <a-button
          type="primary"
          @click="addForm"
        >
          {{ $t('message["915"]') }}
        </a-button>
        <a-button @click="resetAddForm">
          {{ $t('message["896"]') }}
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
  components: {
  },
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    },
    datas: {
      type: Object,
      default () {
        return {}
      }
    },
    serword: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isShow: false,
      isTitShow: false
    }
  },
  computed: {
    ...mapState('config/collect', ['treeDatas', 'decorators']),
    noEmpty () {
      return this.$t('message["67"]')
    },
    enterPlaceholder () {
      return this.$t('message["751"]')
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapMutations('config/collect', ['setTreeData']),
    resetForm () {
      if (this.isShow) {
        this.isShow = false
      }
      this.itemData.title = this.itemData.name
    },
    editName (item) {
      this.isShow = true
    },
    addName () {
      if (this.itemData.level * 1 < 2) {
        this.addLoop(this.datas.options, this.itemData.key)
        this.$emit('addName', this.itemData, this.datas.options)
      } else {
        this.$message.error(this.$t('message["1681"]'))
      }
    },
    addForm () {
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.itemData.title = this.form.getFieldValue('name')
          this.editLoop(this.datas.options, this.itemData)
          this.$emit('addForm', this.datas.options)
        }
      })
    },
    resetAddForm () {
      this.itemData.addShow = false
      this.delLoop(this.datas.options, this.itemData.key)
    },
    delName () {
      this.delLoop(this.datas.options, this.itemData.key)
      delete this.itemData
      this.$emit('addForm', this.datas.options)
    },
    editForm () {
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          if (this.isShow) {
            this.isShow = false
          }
          this.itemData.title = values.name
          this.editLoop(this.datas.options, this.itemData)
          this.$emit('editForm')
        }
      })
    },
    addLoop (arr, key) {
      arr.forEach((item, index) => {
        if (item.key && item.key === key) {
          if (item.children && item.children.length) {
            const b = item.children.some(item => item.name === '')
            if (!b) {
              item.children.push({
                name: '',
                _id: (Math.random() * 10000000).toString(16).substr(0, 4) + '-' + (new Date()).getTime(),
                addShow: true,
                level: item.level + 1,
                pid: item.key
              })
            }
          } else {
            item.children = []
            item.children.push({
              name: '',
              _id: (Math.random() * 10000000).toString(16).substr(0, 4) + '-' + (new Date()).getTime(),
              addShow: true,
              level: item.level + 1,
              pid: item.key
            })
          }
        } else {
          if (item.children && item.children.length) {
            this.addLoop(item.children, key)
          }
        }
      })
    },
    delLoop (arr, key) {
      for (let i = 0; i < arr.length; i++) {
        if (key !== undefined && key === arr[i].key) {
          arr.splice(i, 1)
          return false
        }
        if (arr[i].children && arr[i].children.length) {
          this.delLoop(arr[i].children, key)
        }
      }
    },
    editLoop (arr, itemData) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].key === itemData.key) {
          arr[i].name = itemData.title
          itemData.name = itemData.title
          if (itemData.addShow) {
            itemData.addShow = false
          }
          if (arr[i].addShow) {
            arr[i].addShow = false
            arr[i].title.addShow = false
          }
          return false
        }
        if (arr[i].children && arr[i].children.length) {
          this.editLoop(arr[i].children, itemData)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.item-tree  {
  width: 100%;
  height: 32px;
  line-height: 32px;
  display:block;
  width: 360px;
  margin-left: -20px;
  padding-left: 20px;
  .item-tit-name {
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    display: inline-block;
  }
}
.item-tree .op-tool{
  display: none;
  .edit-icon {
    margin-left: 16px;
    font-size: 16px;
    color: #d6d6d6;
  }
}
.item-tree:hover .op-tool{
  display: inline-block;
}
.add-tree-item-form::v-deep {
  position: relative;
  z-index: 5;
  .ant-form-item-control {
    line-height: 32px;
  }
  .ant-input{
    width: 180px;
  }
  .ant-form-item {
    margin-right: 0 !important;
  }
  .ant-btn{
    margin-right: 0;
    margin-left:16px;
  }

}
.hide {
  display: none;
}
</style>
